import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import SingleImageUploader from "../shared/imageUploaders/singleImage/SingleImageUploader";
import { Form, Input, Row, Col, Button, message } from "antd";
import axios from "axios";
import config from "../../config";

const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || value === "undefined" || value === "null") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem failed for key="${key}"`, e);
    return false;
  }
};

const safeSetJSON = (key, obj) => {
  try {
    localStorage.setItem(key, JSON.stringify(obj));
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem(JSON) failed for key="${key}"`, e);
    return false;
  }
};

const AdminInfoForm = (props) => {
  const history = useHistory();

  // Read user once, safely
  const storedUser = useMemo(
    () => safeJSONParse(localStorage.getItem("user"), {}),
    []
  );

  // Profile Picture
  const [logoUrl, setLogoUrl] = useState(
    props.edit ? (storedUser?.picture || "") : ""
  );

  const nickName = props.edit ? (storedUser?.nickname || "") : "";

  // Submission
  const onFinish = (values) => {
    const doc = JSON.stringify({
      role: "admin",
      nickname: values.displayName,
      picture: logoUrl,
    });

    return axios
      .patch(
        `${config.USERS}/users`,
        {},
        {
          headers: {
            token: localStorage.getItem("access_token"),
            doc: encodeURIComponent(doc),
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          if (props.edit) {
            message.success("You profile has been updated.");
          } else {
            message.success("You have been successfully registered as a User!");
          }

          // Update localStorage safely
          const currentUser = safeJSONParse(localStorage.getItem("user"), {}) || {};
          const updatedUser = {
            ...currentUser,
            picture: logoUrl,
            nickname: values.displayName,
            role: "admin",
          };

          safeSetItem("role", "admin");
          safeSetJSON("user", updatedUser);

          history.push("/");
        } else {
          message.error(
            "Something went wrong, make sure you are connected to the internet."
          );
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Something went wrong updating your profile.");
      });
  };

  // Navigation - Cancel Button
  const backToAccountTypesOptions = () => {
    let path = `/profile-start`;
    if (props.edit) {
      path = "/";
    }
    history.push(path);
  };

  return (
    <Form
      name="userInfoForm"
      className="accountForm"
      onFinish={onFinish}
      layout="vertical"
      initialValues={{
        displayName: `${nickName}`,
      }}
    >
      <Row gutter={[12]}>
        <Col span={24} style={{ marginBottom: "150px" }}>
          <SingleImageUploader
            handleImageUpload={(url) => setLogoUrl(url)}
            imagePreviewUrl={logoUrl}
            typeKey={"user"}
            title="Photo (optional)"
            layout={"logo"}
          />
        </Col>

        <Col span={24}>
          <Form.Item
            label="Display Name"
            name="displayName"
            rules={[
              {
                required: true,
                message: "Please enter display name",
              },
            ]}
          >
            <Input placeholder="Enter display name" />
          </Form.Item>
        </Col>

        <Col span={24} style={{ textAlign: "right" }}>
          <Form.Item>
            <Button
              className="btn-bordered"
              onClick={backToAccountTypesOptions}
              style={{ margin: "0px 5px", width: "85px" }}
              type="text"
            >
              Cancel
            </Button>
            <Button
              className="btn-solid"
              htmlType="submit"
              style={{ margin: "0px 5px", width: "85px" }}
              type="text"
            >
              Save
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default AdminInfoForm;
